'use client';

import { createContext } from 'react';
import type { DataManagementContextType } from '../interfaces/DataManagementContextType';

export const DataManagementContext = createContext<DataManagementContextType<any> | null>(null);
